<template>
	<div class="box">
		<div class="content" v-if="query.status">
			<h3>充值成功！</h3>
			<p>真相搜索团队将尽快为您处理！</p>
			<img src="../../assets/user/Success.png">
		</div>
		<div class="content" v-else>
			<h3>充值失败！</h3>
			<p>真相搜索团队将尽快为您处理！</p>
			<img src="../../assets/user/error.png">
		</div>
	</div>
</template>
<script>
	export default {
		data () {
			return {
				status: false,
				query: {  }
			}
		},
		mounted () {
			this.query = this.$queryUrlParams();
		},
		methods: {

		}
	}
</script>
<style scoped>
.clearfix:after{
	content:".";
	display:block;
	height:0;
	clear:both;
	visibility:hidden
}
.clearfix{
	*+height:1%;
}
body,html,h3,ul,li{
	margin:0;
	padding:0;
}
li{
	list-style: none;
}
.content{
	width: 640px;
	height: 400px;
	margin: 70px auto 0 auto;
	text-align: center;
	border: none;
}
.content > img{
	margin-top:40px;
}
.content > h3{
	margin-top:10px;
	color:#ccc;
}
.content > p{
	margin-top:20px;
	color:#333;
}
</style>



// WEBPACK FOOTER //
// ChargeResult.vue?842e0f02